import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ConfigService,
  GsResponsiveDirective,
  ImageService,
  InformationService,
  LanguageService,
  MyChainstoreService,
  SOCIAL_MEDIA_ICON_MAP,
  StyleService,
  SystemService
} from 'libs/shared/src';
import { GsIconComponent } from 'libs/shared/src/components/gs-icon/gs-icon.component';
import { SidebarMenuComponent } from '../../../sidebar-menu/sidebar-menu.component';
import { HeaderService } from '../../services/header.service';

/**
 * The off-canvas navigation of the header: logo, my-chainstore and language switch, the drill-down
 * menu, the account actions, opening hours and social links. Shared by all header variants; opened
 * and closed through `SystemService.toggleSidebar()`.
 */
@Component({
  selector: 'header-sidebar',
  imports: [CommonModule, NgOptimizedImage, TranslatePipe, GsIconComponent, GsResponsiveDirective, SidebarMenuComponent],
  templateUrl: './header-sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class HeaderSidebarComponent {
  // Services
  protected readonly config = inject(ConfigService);
  protected readonly headerService = inject(HeaderService);
  protected readonly imageService = inject(ImageService);
  protected readonly infoService = inject(InformationService);
  protected readonly languageService = inject(LanguageService);
  protected readonly myChainstoreService = inject(MyChainstoreService);
  protected readonly styleService = inject(StyleService);
  protected readonly system = inject(SystemService);

  // Properties & Signals
  /** Icon names per social media key */
  protected readonly SOCIAL_MEDIA_ICON_MAP = SOCIAL_MEDIA_ICON_MAP;
}
